import DefaultDemande from "../../innedit_src/containers/Demande";
import Item from "./Item";

class Demande extends DefaultDemande {
  view = Item;
}

export default Demande;
